import wixFullstoryLoader from '@wix/wix-fullstory-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { isLoggedIn } from './auth/user';
import App from './components/App';
import ErrorBoundary from './components/App/ErrorBoundary';
import Modal from './components/modals/core/Modal';
import i18n from './i18n';
import biLogger from './lib/bi/biLogger';
import {
  getPrefixedWizardSessionId,
  getWizardSessionId,
} from './lib/wizardSession';
import configureStore from './redux/configureStore';
import { initExperiments } from './redux/experiments/operations';

const experiments = window.__EXPERIMENTS__;

// TODO: use experiment, when it available in petri
wixFullstoryLoader({
  label: 'vmaf',
  // spec: FULL_STORY_SPEC,
  sample: 0.5,
});

biLogger.updateDefaults({
  sessionId: isLoggedIn() ? getPrefixedWizardSessionId() : getWizardSessionId(),
});

const { store, persistor } = configureStore({
  blacklist: ['experiments'],
});

store.dispatch(initExperiments(experiments));

const container = document.getElementById('root')!;

Modal.setAppElement(container);

function render(AppComponent: React.ComponentType<any>) {
  ReactDOM.render(
    <ErrorBoundary>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <PersistGate persistor={persistor}>
            <AppComponent />
          </PersistGate>
        </I18nextProvider>
      </Provider>
    </ErrorBoundary>,
    container,
  );
}

render(App);

if (module.hot) {
  module.hot.accept('./components/App', () => {
    import('./components/App').then(
      (module) => {
        render(module.default);
      },
      (error) => {
        console.warn(`HMR error`, error);
      },
    );
  });
}
